<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :style="{ width: '450px' }"
    :header="t('myShopData.actions.delete')"
  >
    <div class="p-fluid">
      <p>{{ t('customData.syncList.confirmDelete') }}</p>
      <p
        v-if="currentPayload?.schemaItem"
        class="font-semibold mt-2"
      >
        {{ currentPayload.schemaItem.schema_name }}
      </p>
    </div>
    <template #footer>
      <SpmButton
        :label="t('no')"
        icon="pi pi-times"
        class-style="p-button p-button-secondary"
        @click="close"
      />
      <SpmButton
        :label="t('yes')"
        icon="pi pi-check"
        class-style="p-button p-button-danger"
        @click="confirm"
      />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import type { ActionPayload, DeleteSchemaResult } from './types';

export default defineComponent({
  name: 'DeleteSchemaAction',

  components: {
    Dialog,
    SpmButton,
  },

  emits: ['confirm'],

  setup(_, { emit, expose }) {
    const { t } = useI18n();

    const isVisible = ref(false);
    const currentPayload = ref<ActionPayload | null>(null);

    /**
     * Open the dialog with the given payload
     */
    const open = (payload: ActionPayload) => {
      currentPayload.value = payload;
      isVisible.value = true;
    };

    /**
     * Close the dialog
     */
    const close = () => {
      isVisible.value = false;
      currentPayload.value = null;
    };

    /**
     * Confirm the action and emit result
     */
    const confirm = () => {
      if (!currentPayload.value) return;

      const result: DeleteSchemaResult = {
        schemaItem: currentPayload.value.schemaItem,
      };

      emit('confirm', result);
      close();
    };

    // Expose open method for parent component
    expose({ open });

    return {
      t,
      isVisible,
      currentPayload,
      close,
      confirm,
    };
  },
});
</script>
